// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","2608":"1c521f06","4929":"8f6b5855","5122":"1f3a2121","5912":"aec78970"}[chunkId] + ".css";
};